var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-not-allowed"},[_c('div',{staticClass:"widget-image"},[_c('b-icon',{staticStyle:{"font-size":"130px"},attrs:{"icon":"block-helper","size":"is-large"}})],1),_c('div',{staticClass:"widget-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"widget-subtitle"},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }